module.exports = {
  name: 'Русский',
  key: 'ru',
  'Open in Debug Map': 'Открыть в отладочной карте',
  'Open in Mapillary': 'Открыть в Mapillary',
  'GPX': 'Сохранить маршрут в файл GPX',
  'Open in editor': 'Открыть в редакторе',
  'Open in JOSM': 'Открыть в редакторе JOSM',
  'Select language': 'Выбрать язык',
  'Share Route': 'Поделиться маршрутом',
  'Link': 'Ссылка',
  'Shortlink': 'Короткая ссылка',
  'Start - press enter to drop marker': 'Начало - нажмите Enter, чтобы удалить маркер',
  'End - press enter to drop marker': 'Конец - нажмите Enter, чтобы удалить маркер',
  'Via point - press enter to drop marker': 'Промежуточная точка - нажмите Enter, чтобы удалить маркер',
  'Build': 'Сборка: '
};
